import { useEffect, useRef } from "react";

// Renders the MindPal advanced iframe pattern: config first, then iframe, then iframe.min.js.
export const MindPalEmbed = ({ elementId, host, slug, userId, context }) => {
  const ref = useRef(null);
  const ctxKey = JSON.stringify(context);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    el.innerHTML = "";
    window.mindpalIframeConfig = {
      ...(window.mindpalIframeConfig || {}),
      [elementId]: { customUserId: userId, customSessionContext: JSON.parse(ctxKey) },
    };
    const iframe = document.createElement("iframe");
    iframe.id = elementId;
    iframe.src = `https://${host}.getmindpal.com/${slug}${host === "workflow" ? `?cuid=${encodeURIComponent(userId)}` : ""}`;
    iframe.title = "Agentic Brain run surface";
    iframe.setAttribute("allow", "clipboard-read; clipboard-write; microphone");
    iframe.setAttribute("style", "width:100%; height:100%; min-height:760px");
    el.appendChild(iframe);
    const script = document.createElement("script");
    script.src = `https://${host}.getmindpal.com/iframe.min.js`;
    script.setAttribute("data-target", elementId);
    el.appendChild(script);
    return () => {
      el.innerHTML = "";
      if (window.mindpalIframeConfig) delete window.mindpalIframeConfig[elementId];
    };
  }, [elementId, host, slug, userId, ctxKey]);

  return <div ref={ref} className="h-full min-h-[760px] w-full" data-testid="run-surface-container" />;
};
